import styled from 'styled-components';

export const DesktopOnly = styled.span`
  display: none;

  ${({ theme }) => theme.mediaBreakpointUp.md} {
    display: inline;
  }
`;

export const MobileOnly = styled.span`
  ${({ theme }) => theme.mediaBreakpointUp.md} {
    display: none;
  }
`;
